<template>
  <v-expansion-panels
    v-model="tray"
    multiple
    flat
    :class="{ 'no-cassettes': cassettesToShow.length === 0}"
  >
    <cassette
      v-for="cassette of cassettesToShow"
      :key="cassette.uuid"
      :cassette="cassette"
      :connections="getCassetteConnections(cassette)"
      @open-cassette-connection-menu="$event => openMenu($event)"
      @open-cassette-form="$emit('open-cassette-form', $event)"
      @open-tube-form="openTubeForm"
      @open-delete-cassette-dialog="$emit('open-delete-cassette-dialog', $event)"
    />
    <span v-if="cassettesToShow && cassettesToShow.length === 0" :style="cassettesToShow.length === 0 ? { 'margin-top': '0' } : { 'margin-top': '45%'}">
      {{ $t('DrawerHasNoCassettes') }}
    </span>
  </v-expansion-panels>
</template>

<script>
import Cassette from "./Cassette.vue";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "Drawer",

  components: {
    Cassette
  },

  props: {
    selectedDrawer: {
      type: Object,
      required: false,
    },

    connections: {
      type: Array
    },

    cassettes: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      tray: [],
    }
  },

  computed: {
    cassettesToShow() {
      return this.selectedDrawer ? this.selectedDrawer.cassettes : this.cassettes;
    },
  },

  methods: {
    /**
     * Emits an event to open the clicked fiber menu
     *
     * @param {Object} data the data of the selected fiber, contains the id and connection side of the fiber
     */
    openMenu(data) {
      this.$emit('open-tray-connection-menu', data.e.clientX, data.e.clientY, data.fiberId, data.side);
    },

    /**
     * Emits an event to open the tube form
     *
     * @param {String} connectionSide the side of the selected fiber
     * @param {Object} cassette an object with the data of the selected cassette
     * @param {Number} leftoverCapacity the number of leftover spaces in the cassette
     * @param {String} connectionId the string of the selected fiber
     */
    openTubeForm(connectionSide, cassette, leftoverCapacity, cassetteCapacity, positionInCassette, connectionId = null) {
      this.$emit('open-tube-form', connectionSide, cassette, leftoverCapacity, cassetteCapacity, positionInCassette, connectionId);
    },

    /**
     * Filters the connections according to the selected casssette id
     * @param {String} cassetteId the id of the selected cassette
     */
    getCassetteConnections(cassette) {
      let cassetteId = cassette.ct_id;
      let cassetteCapacity = cassette.ct_capacity;
      let isVirtualCassette = cassetteCapacity === 9999999;
      let cassetteConnections = [];
      if (cassetteId && this.connections) {
        cassetteConnections = isVirtualCassette
          ? this.connections.filter(connection => connection.trayNumber === cassetteId && (connection.originFiberID || connection.destinationFiberID))
          : this.connections.filter(connection => connection.trayNumber === cassetteId);
      }
      if (isVirtualCassette) {
        cassetteConnections.push({
          connectionId: uuidv4(),
          mode: "EMPTY",
          trayFace: cassette.ct_face,
          trayIndex: cassette.ct_index,
          trayLabel: cassette.ct_label,
          trayMaterial: cassette.ct_material_id,
          trayNumber: cassette.ct_id,
          trayParentDrawerId: cassette.ct_drawer_id,
        })
      }
      return cassetteConnections;
    },
  }
}
</script>

<style>
.v-expansion-panels {
  align-content: flex-start;
  width: 95%;
  overflow-y: scroll;
  min-height: 250px;
}

.v-expansion-panels.no-cassettes {
  width: 95%;
  overflow-y: scroll;
  min-height: 250px;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}

</style>
<style scoped>
::-webkit-scrollbar {
  display: none;
  width: 95% !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/Drawer.vue